// Effect Managers
import { put, call, fork } from 'redux-saga/effects'

// Exports
export default function composeDelete ({
  state,
  actionCreators,
  handler,
}) {
  const delete_ = function *delete_ (
    { url, id: maybeId, model, queryParams } = {},
    { block = true, meta = {} } = {}
  ) {
    const id = maybeId || model.id

    if (!block && state.get().watch.delete) {
      const action = actionCreators.fetch({
        url,
        id,
        model,
        queryParams,
      }, {
        meta,
      })

      yield put(action)
    } else {
      const result = yield call(handler, { url, id, model, queryParams })
      return result
    }
  }

  const deleteNonBlocking = function *deleteNonBlocking (
    payload = {},
    { meta = {} } = {}
  ) {
    yield fork(delete_, payload, {
      block: false,
      meta,
    })
  }

  return {
    delete_,
    deleteNonBlocking,
  }
}
